import clsx from "clsx";
import { Link } from "gatsby";
import React from "react";

import { Breadcrumb } from "../../types/breadcrumbs";

export interface BreadcrumbItemProps extends Breadcrumb {
  disabled?: boolean;
  linkClassName?: string;
  disabledClassName?: string;
}

export function BreadcrumbItem({
  label,
  url,
  disabled,
  disabledClassName,
  linkClassName,
}: BreadcrumbItemProps) {
  if (disabled || !url) {
    return <span className={disabledClassName}>{label}</span>;
  }

  return (
    <Link className={clsx("hover:underline font-semibold", linkClassName)} to={url}>
      {label}
    </Link>
  );
}
